module.exports=function(scope){ return `# Call /match-3d-3d or /match-3d-2d based on data you are matching
# The source object must have EITHER an enrollmentIdentifier or faceMap parameter
# The target object must have a faceMap

curl -X POST \
'https://api.zoomauth.com/api/v2/biometrics/match-3d-3d' \
-H 'Content-Type: application/json' \
-H 'X-Device-License-Key: ${scope.appToken}' \
-H 'X-User-Agent: ZoomSDK.createZoomAPIUserAgentString(INSERT_SESSION_ID_FROM_zoomSessionResult)' \
-d '{
    "source": {
        "enrollmentIdentifier": INSERT_ENROLLMENT_IDENTIFIER_HERE
    },
    "target": {
        "faceMap": INSERT_FACEMAP_FROM_zoomSessionResult
    },
    "sessionId": INSERT_SESSION_ID_FROM_zoomSessionResult,
    "auditTrailImage": INSERT_AUDIT_TRAIL_IMAGE_FROM_zoomSessionResult,
    "lowQualityAuditTrailImage": INSERT_LOW_QUALITY_AUDIT_TRAIL_IMAGE_FROM_zoomSessionResult
}'
`};


// WEBPACK FOOTER //
// ./src/resources/code/webservice-v2/bash/compare.bash.tpl